import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Ribbon.svg'
import _imports_1 from '@/assets/images/Cardnoise.png'


const _withScopeId = n => (_pushScopeId("data-v-28d7319a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "greeting-card" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ribbons" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "granule" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: `${_ctx.publicPath}skin/${_ctx.skinImage}.jpg`,
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("p", {
      class: "greetings",
      style: _normalizeStyle(_ctx.greetingStyle)
    }, _toDisplayString(_ctx.greetingCheck), 5),
    _hoisted_4,
    _hoisted_5
  ]))
}